/* ==========================================================
   Sculptique V3 PDP
   Loaded only for templates/product.main_product_lymph-updated-bf-champs-selector-unisex-neselectorv2.json
   (layout/theme.liquid). Every hook is a data-v3-* attribute.

   Zones: head, middle, pelvis, legs, whole
   ========================================================== */

(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOBILE = window.matchMedia('(max-width: 768px)');

  // ?angle= value -> zone + tile handle (tile handles are set per tile block).
  var ANGLES = {
    eyes: { zone: 'head', tile: 'eyes' },
    brainfog: { zone: 'head', tile: 'brainfog' },
    bloating: { zone: 'middle', tile: 'bloating' },
    weight: { zone: 'middle', tile: 'weight' },
    liver: { zone: 'middle', tile: 'liver' },
    cholesterol: { zone: 'middle', tile: 'cholesterol' },
    nights: { zone: 'pelvis', tile: 'nights' },
    prostate: { zone: 'pelvis', tile: 'prostate' },
    kidney: { zone: 'pelvis', tile: 'kidney' },
    legs: { zone: 'legs', tile: 'legs' },
    cellulite: { zone: 'legs', tile: 'cellulite' },
    energy: { zone: 'whole', tile: 'energy' },
    stiffness: { zone: 'whole', tile: 'stiffness' },
    labs: { zone: 'whole', tile: 'labs' }
  };

  function readAngle() {
    try {
      var value = new URLSearchParams(window.location.search).get('angle');
      value = value ? value.trim().toLowerCase() : '';
      return ANGLES[value] ? value : '';
    } catch (e) {
      return '';
    }
  }

  var ANGLE = readAngle();

  /* ---------------------------------------------------------------- *
   *  Tracking: GTM dataLayer + gtag when present.
   * ---------------------------------------------------------------- */
  function track(name, data) {
    data = data || {};
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      Object.keys(data).forEach(function (key) { payload[key] = data[key]; });
      window.dataLayer.push(payload);
      if (typeof window.gtag === 'function') window.gtag('event', name, data);
    } catch (e) {
      /* tracking must never break the page */
    }
  }

  /* ---------------------------------------------------------------- *
   *  Scrolling, leaving room for the sticky header.
   * ---------------------------------------------------------------- */
  function stickyHeaderOffset() {
    var header = document.querySelector('.section-header') || document.querySelector('sticky-header');
    if (!header) return 0;
    var position = getComputedStyle(header).position;
    return position === 'sticky' || position === 'fixed' ? header.offsetHeight : 0;
  }

  function scrollToElement(target) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - stickyHeaderOffset() - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: REDUCED_MOTION ? 'auto' : 'smooth' });
  }

  /* ---------------------------------------------------------------- *
   *  Selectors in page order: the buy box, and the bottom product
   *  section (a second copy of the main product section).
   * ---------------------------------------------------------------- */
  function selectorTargets() {
    return Array.prototype.slice.call(document.querySelectorAll('.ns-selector'));
  }

  function buyboxSelector() {
    return selectorTargets()[0] || null;
  }

  // The last selector, when the page has more than one.
  function bottomSelector() {
    var selectors = selectorTargets();
    return selectors.length > 1 ? selectors[selectors.length - 1] : null;
  }

  function nearestSelector() {
    var middle = window.innerHeight / 2;
    var best = null;
    var bestDistance = Infinity;
    selectorTargets().forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var distance = Math.abs(rect.top + rect.height / 2 - middle);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = el;
      }
    });
    return best;
  }

  function scrollTarget(kind) {
    if (kind === 'buybox') return buyboxSelector() || nearestSelector();
    if (kind === 'bottom') return bottomSelector() || nearestSelector();
    return nearestSelector();
  }

  /* ---------------------------------------------------------------- *
   *  CTA targets:
   *  [data-v3-scroll="buybox|bottom|nearest"]. Legacy theme buttons
   *  (.product_primary-btn.scrolling, [data-btn-type="scroll"]) are taken
   *  in the capture phase so sitewide.js does not jump to the top
   *  container; they go to the nearest selector.
   * ---------------------------------------------------------------- */
  function initScrollLinks() {
    document.addEventListener(
      'click',
      function (event) {
        if (!event.target.closest) return;
        var link = event.target.closest('[data-v3-scroll], .product_primary-btn.scrolling, [data-btn-type="scroll"]');
        if (!link) return;
        var target = scrollTarget(link.getAttribute('data-v3-scroll') || 'nearest');
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        scrollToElement(target);
      },
      true
    );
  }

  /* ---------------------------------------------------------------- *
   *  Two selectors, one choice: a click on a tier in one product
   *  section is repeated on the same tier in the other. new-selector.js
   *  handles each click (scoped per .ns-selector); because both always
   *  hold the same tier, its shared .ns-atc handler (first selected
   *  tier on the page) sends the right link.
   * ---------------------------------------------------------------- */
  var syncing = false;

  function selectIndex(selector, index) {
    var tier = selector.querySelector('.ns-tier[data-index="' + index + '"]');
    if (!tier || tier.classList.contains('ns-tier--selected')) return;
    syncing = true;
    window.jQuery(tier).trigger('click');
    syncing = false;
  }

  function initSelectorSync() {
    if (!window.jQuery) return;
    window.jQuery(document).on('click', '.ns-tier', function () {
      if (syncing) return;
      var index = this.getAttribute('data-index');
      var own = this.closest('.ns-selector');
      selectorTargets().forEach(function (selector) {
        if (selector !== own) selectIndex(selector, index);
      });
    });
  }

  /* ---------------------------------------------------------------- *
   *  Two product sections on one page: sitewide.js links every mobile
   *  gallery to every thumb strip (asNavFor by class), so they would
   *  move together. Re-link each pair inside its own section, with the
   *  same Slick options as sitewide.js.
   * ---------------------------------------------------------------- */
  function relinkGalleries() {
    var $ = window.jQuery;
    if (!$ || !$.fn.slick) return;
    var carousels = $('.main_product-image-carousel');
    if (carousels.length < 2) return;

    carousels.each(function () {
      var section = this.closest('.shopify-section');
      if (!section || !section.id) return;
      var scope = '#' + section.id + ' ';
      var $main = $(scope + '.main_product-image-carousel');
      var $thumbs = $(scope + '.main_product-image-carousel_thumbs');

      if ($main.hasClass('slick-initialized')) $main.slick('unslick');
      if ($thumbs.hasClass('slick-initialized')) $thumbs.slick('unslick');

      $main.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: $thumbs.length ? scope + '.main_product-image-carousel_thumbs' : null,
        prevArrow:
          "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin_1.png?v=1752126281'/></button>",
        nextArrow:
          "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin.png?v=1752126281'/></button>"
      });

      if ($thumbs.length) {
        $thumbs.slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          focusOnSelect: true,
          asNavFor: scope + '.main_product-image-carousel'
        });
      }
    });
  }

  /* ---------------------------------------------------------------- *
   *  b10_selector_view: the bottom selector came into view (once).
   * ---------------------------------------------------------------- */
  function initBottomSelectorView() {
    var bottom = bottomSelector();
    if (!bottom || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      track('b10_selector_view');
      observer.disconnect();
    }, { threshold: 0.3 });
    observer.observe(bottom);
  }

  /* ---------------------------------------------------------------- *
   *  Sticky add to cart (mobile only).
   *  Shown once the buy-box button has scrolled above the viewport,
   *  hidden while either selector is on screen.
   * ---------------------------------------------------------------- */
  function initSticky() {
    var sticky = document.querySelector('[data-v3-sticky]');
    var atc = document.querySelector('.ns-atc');
    if (!sticky || !atc || !('IntersectionObserver' in window)) return;

    var atcPassed = false;
    var visibleSelectors = new Set();

    function update() {
      var show = MOBILE.matches && atcPassed && visibleSelectors.size === 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) sticky.removeAttribute('inert');
      else sticky.setAttribute('inert', '');
    }

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      atcPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    }).observe(atc);

    var selectorObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visibleSelectors.add(entry.target);
        else visibleSelectors.delete(entry.target);
      });
      update();
    });
    selectorTargets().forEach(function (el) { selectorObserver.observe(el); });

    if (MOBILE.addEventListener) MOBILE.addEventListener('change', update);

    var button = sticky.querySelector('[data-v3-sticky-btn]') || sticky;
    fitStickyButton(button);
    button.addEventListener('click', function (event) {
      event.preventDefault();
      track('sticky_atc_click');
      var target = nearestSelector();
      if (target) scrollToElement(target);
    });

    update();
  }

  // Keeps the sticky button label on one line: the font only steps down when the label is wider than the button.
  function fitStickyButton(button) {
    var label = button.querySelector('[data-v3-sticky-label]');
    if (!label) return;

    function fit() {
      button.style.fontSize = '';
      var style = getComputedStyle(button);
      var room = button.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      var size = parseFloat(style.fontSize);
      while (label.offsetWidth > room && size > 12) {
        size -= 0.5;
        button.style.fontSize = size + 'px';
      }
    }

    fit();
    window.addEventListener('resize', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  /* ---------------------------------------------------------------- *
   *  Symptom router.
   *  [data-v3-router] with [data-v3-zone-btn] (hotspots + buttons),
   *  [data-v3-zone-panel] and <details data-v3-tile> tiles.
   *  One zone at a time; one open tile at a time.
   * ---------------------------------------------------------------- */
  function selectZone(router, zone) {
    var panel = router.querySelector('[data-v3-zone-panel="' + zone + '"]');
    if (!panel) return false;
    router.querySelectorAll('[data-v3-zone-btn]').forEach(function (btn) {
      var active = btn.getAttribute('data-v3-zone-btn') === zone;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    router.querySelectorAll('[data-v3-zone-panel]').forEach(function (p) {
      p.hidden = p !== panel;
    });
    // Body map image of the selected zone
    router.querySelectorAll('[data-v3-zone-image]').forEach(function (img) {
      var active = img.getAttribute('data-v3-zone-image') === zone;
      img.classList.toggle('is-active', active);
      img.alt = active ? img.getAttribute('data-alt') || '' : '';
    });
    router.setAttribute('data-v3-zone', zone);
    return true;
  }

  function initRouter(router) {
    if (router.hasAttribute('data-v3-ready')) return;
    router.setAttribute('data-v3-ready', '');

    router.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-v3-zone-btn]');
      if (!btn || !router.contains(btn)) return;
      event.preventDefault();
      selectZone(router, btn.getAttribute('data-v3-zone-btn'));
    });

    router.querySelectorAll('details[data-v3-tile]').forEach(function (tile) {
      tile.addEventListener('toggle', function () {
        if (!tile.open) return;
        router.querySelectorAll('details[data-v3-tile][open]').forEach(function (other) {
          if (other !== tile) other.open = false;
        });
        if (tile.hasAttribute('data-v3-silent')) {
          tile.removeAttribute('data-v3-silent');
          return;
        }
        track('router_tile_open', {
          zone: router.getAttribute('data-v3-zone') || '',
          angle: ANGLE
        });
      });
    });

    var defaultZone = router.getAttribute('data-v3-default-zone') || 'middle';
    var angle = ANGLE ? ANGLES[ANGLE] : null;

    if (angle && selectZone(router, angle.zone)) {
      var tile = router.querySelector('details[data-v3-tile="' + angle.tile + '"]');
      if (tile) {
        tile.setAttribute('data-v3-silent', ''); // opened by the page, not by the visitor
        tile.open = true;
      }
    } else {
      selectZone(router, defaultZone);
    }
  }

  /* ---------------------------------------------------------------- *
   *  ?angle=: pulse the zone on the 2nd gallery image (body map).
   *  Positions come from the router section
   *  (<script type="application/json" data-v3-gallery-spots>).
   * ---------------------------------------------------------------- */
  function galleryTargets() {
    var targets = [];
    // Image 2 of the desktop gallery: first cell of the 2-image row
    // (snippets/v3-gallery.liquid), or the old gallery's 2nd image.
    var desktop = document.querySelector('.v3-gallery .v3-gallery__row--2 .v3-gallery__cell') ||
      document.querySelector('.main_product-images.Desktop_only .main_product-2nd:not(.bottom) > div:first-child');
    if (desktop) targets.push(desktop);

    var carousel = document.querySelector('.main_product-image-carousel');
    if (carousel) {
      var slide = carousel.classList.contains('slick-initialized')
        ? carousel.querySelector('.slick-slide:not(.slick-cloned)[data-slick-index="1"]')
        : carousel.children[1];
      var box = slide && (slide.querySelector('.main_product-image-box') || slide);
      if (box) targets.push(box);
    }
    return targets;
  }

  function initGalleryPulse() {
    if (!ANGLE) return;
    var data = document.querySelector('[data-v3-gallery-spots]');
    if (!data) return;
    var spots;
    try {
      spots = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }
    var spot = spots[ANGLES[ANGLE].zone];
    if (!spot) return;

    galleryTargets().forEach(function (target) {
      target.classList.add('v3-gallery-target');
      var pulse = document.createElement('span');
      pulse.className = 'v3-gallery-pulse';
      pulse.setAttribute('aria-hidden', 'true');
      pulse.style.left = spot.x + '%';
      pulse.style.top = spot.y + '%';
      target.appendChild(pulse);
    });
  }

  /* ---------------------------------------------------------------- *
   *  Reviews (sections/v3-reviews.liquid): tabs All + 5 zones.
   *  Tab values and card zones use the router zone keys (head, middle,
   *  pelvis, legs, whole), so ?angle= presets the matching tab
   *  (ANGLES[angle].zone). Cards [data-v3-review-zone] are paged: the
   *  first page of the current tab shows, "Load more" adds the next.
   *  Page size: data-v3-page-desktop / data-v3-page-mobile.
   * ---------------------------------------------------------------- */
  function reviewPageSize(reviews) {
    var attr = MOBILE.matches ? 'data-v3-page-mobile' : 'data-v3-page-desktop';
    return parseInt(reviews.getAttribute(attr), 10) || 4;
  }

  function matchingCards(reviews, tabValue) {
    return Array.prototype.filter.call(reviews.querySelectorAll('[data-v3-review-zone]'), function (card) {
      return tabValue === 'all' || card.getAttribute('data-v3-review-zone') === tabValue;
    });
  }

  function renderReviews(reviews) {
    var tabValue = reviews.getAttribute('data-v3-tab') || 'all';
    var limit = parseInt(reviews.getAttribute('data-v3-limit'), 10) || reviewPageSize(reviews);
    var matches = matchingCards(reviews, tabValue);
    reviews.querySelectorAll('[data-v3-review-zone]').forEach(function (card) {
      var index = matches.indexOf(card);
      card.hidden = index === -1 || index >= limit;
    });
    // "Load more" stays visible (as in the design) until a click has
    // revealed every review of the current tab.
    var more = reviews.querySelector('[data-v3-review-more]');
    if (more) more.hidden = reviews.hasAttribute('data-v3-paged') && matches.length <= limit;
  }

  // Returns false when the tab doesn't exist or has no reviews.
  function showReviewTab(reviews, tabValue) {
    var tab = reviews.querySelector('[data-v3-review-tab="' + tabValue + '"]');
    if (!tab || !matchingCards(reviews, tabValue).length) return false;
    reviews.querySelectorAll('[data-v3-review-tab]').forEach(function (other) {
      var active = other === tab;
      other.classList.toggle('is-active', active);
      other.setAttribute('aria-selected', active ? 'true' : 'false');
      other.tabIndex = active ? 0 : -1;
    });
    reviews.setAttribute('data-v3-tab', tabValue);
    reviews.setAttribute('data-v3-limit', reviewPageSize(reviews));
    reviews.removeAttribute('data-v3-paged');
    renderReviews(reviews);
    return true;
  }

  function initReviews(reviews) {
    if (reviews.hasAttribute('data-v3-ready')) return;
    reviews.setAttribute('data-v3-ready', '');

    var tabs = Array.prototype.slice.call(reviews.querySelectorAll('[data-v3-review-tab]'));

    reviews.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-v3-review-tab]');
      if (tab) {
        var value = tab.getAttribute('data-v3-review-tab');
        if (!showReviewTab(reviews, value)) {
          // Empty zone: still select the tab so the click is visible.
          reviews.setAttribute('data-v3-tab', value);
          tabs.forEach(function (other) {
            var active = other === tab;
            other.classList.toggle('is-active', active);
            other.setAttribute('aria-selected', active ? 'true' : 'false');
            other.tabIndex = active ? 0 : -1;
          });
          renderReviews(reviews);
        }
        track('review_tab_click', { tab: value });
        return;
      }

      var more = event.target.closest('[data-v3-review-more]');
      if (more) {
        reviews.setAttribute('data-v3-paged', '');
        var limit = parseInt(reviews.getAttribute('data-v3-limit'), 10) || reviewPageSize(reviews);
        reviews.setAttribute('data-v3-limit', limit + reviewPageSize(reviews));
        renderReviews(reviews);
      }
    });

    // Arrow keys move between tabs (WAI-ARIA tabs pattern).
    reviews.addEventListener('keydown', function (event) {
      var index = tabs.indexOf(event.target);
      if (index === -1) return;
      var next = null;
      if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
      if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
      if (!next) return;
      event.preventDefault();
      next.focus();
      next.click();
    });

    // ?angle= presets the zone tab (no scroll); otherwise, or when that
    // zone has no reviews, "All".
    if (!(ANGLE && showReviewTab(reviews, ANGLES[ANGLE].zone))) {
      showReviewTab(reviews, 'all');
    }
  }

  /* ---------------------------------------------------------------- *
   *  Customer stories: [data-v3-story] tiles play their video inline
   *  (one at a time). Mobile row: progress thumb + "n / N" counter.
   * ---------------------------------------------------------------- */
  function initStories(row) {
    if (row.hasAttribute('data-v3-ready')) return;
    row.setAttribute('data-v3-ready', '');

    var tiles = Array.prototype.slice.call(row.querySelectorAll('[data-v3-story]'));

    tiles.forEach(function (tile) {
      var video = tile.querySelector('video');
      var button = tile.querySelector('[data-v3-story-play]');
      if (!video || !button) return;

      button.addEventListener('click', function () {
        tiles.forEach(function (other) {
          var otherVideo = other.querySelector('video');
          if (other !== tile && otherVideo && !otherVideo.paused) otherVideo.pause();
        });
        tile.classList.add('is-playing');
        video.controls = true;
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      });

      video.addEventListener('ended', function () {
        tile.classList.remove('is-playing');
        video.controls = false;
      });
    });

    var scroller = row.querySelector('[data-v3-story-track]');
    var thumb = row.querySelector('[data-v3-story-thumb]');
    var counter = row.querySelector('[data-v3-story-count]');
    if (!scroller || !tiles.length) return;

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      var progress = max > 0 ? scroller.scrollLeft / max : 0;
      if (thumb) {
        thumb.style.width = (100 / tiles.length) + '%';
        thumb.style.transform = 'translateX(' + (progress * (tiles.length - 1) * 100) + '%)';
      }
      if (counter) {
        var step = tiles[0].getBoundingClientRect().width + 10;
        var index = Math.min(tiles.length, Math.round(scroller.scrollLeft / step) + 1);
        counter.textContent = index + ' / ' + tiles.length;
      }
    }

    scroller.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  /* ---------------------------------------------------------------- *
   *  Scroll fill ("Meet The System Nobody Checks").
   *  The brief asks for the lymph network to fill as the section moves
   *  through the viewport ([data-v3-fill] sits on the body visual), so this one effect is tied to scroll position
   *  (an exception to the build rules' "class flips" preference). It
   *  only listens while the section is on screen and writes one custom
   *  property per frame: --v3-fill, 0 → 1.
   *  Reduced motion: static and fully green.
   * ---------------------------------------------------------------- */
  /* ---------------------------------------------------------------- *
   *  [data-v3-steps] (system body map): when the green fill reaches a
   *  red pill (its vertical centre), the pill turns into its green pair
   *  and the body image moves one step on. Image n is shown with every
   *  image below it, so steps fade over each other seamlessly, both ways.
   * ---------------------------------------------------------------- */
  function createSteps(visual) {
    var capsule = visual.querySelector('.v3-capsule');
    var pills = Array.prototype.slice.call(visual.querySelectorAll('[data-v3-pill-pair]'));
    var images = Array.prototype.slice.call(visual.querySelectorAll('[data-v3-step-image]'));
    var reds = pills.filter(function (pill) { return pill.classList.contains('v3-pill--backed'); });
    var current = -1;
    var centres = [];

    // Where each red pill sits (its vertical centre), as a share of the capsule
    function measure() {
      var height = capsule ? capsule.offsetHeight : visual.offsetHeight;
      centres = reds.map(function (pill) {
        return {
          pair: pill.getAttribute('data-v3-pill-pair'),
          at: height ? (pill.offsetTop + pill.offsetHeight / 2) / height : 1
        };
      }).sort(function (a, b) { return a.at - b.at; });
    }

    function show(count) {
      if (count === current) return;
      current = count;
      var cleared = {};
      centres.forEach(function (c, i) { if (i < count) cleared[c.pair] = true; });
      pills.forEach(function (pill) {
        pill.classList.toggle('is-cleared', !!cleared[pill.getAttribute('data-v3-pill-pair')]);
      });
      var step = Math.min(count, images.length - 1);
      images.forEach(function (img, i) {
        img.classList.toggle('is-on', i <= step);
      });
    }

    // Switch to the start state (step 1, red pills) without animating it.
    visual.classList.add('is-instant', 'is-armed');
    measure();
    window.addEventListener('resize', measure);
    show(0);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        visual.classList.remove('is-instant');
      });
    });

    return {
      update: function (fill) {
        var count = 0;
        centres.forEach(function (c) {
          if (fill >= c.at) count += 1;
        });
        show(count);
      }
    };
  }

  /* ---------------------------------------------------------------- *
   *  Scroll-linked fills share ONE scroll listener and one rAF per
   *  frame: first every active element's position is read, then every
   *  --v3-fill is written. Reading and writing in turn per element made
   *  the browser recalculate layout several times per frame (lag).
   *  Heights are cached and only re-measured on resize.
   * ---------------------------------------------------------------- */
  var fills = [];
  var fillTicking = false;

  function fillFrame() {
    fillTicking = false;
    var view = window.innerHeight;
    var active = fills.filter(function (f) { return f.active; });
    // 1. read
    var tops = active.map(function (f) { return f.el.getBoundingClientRect().top; });
    // 2. write
    active.forEach(function (f, i) { f.apply(tops[i], view); });
  }

  function requestFillFrame() {
    if (fillTicking) return;
    fillTicking = true;
    window.requestAnimationFrame(fillFrame);
  }

  window.addEventListener('scroll', requestFillFrame, { passive: true });
  window.addEventListener('resize', function () {
    fills.forEach(function (f) { f.measure(); });
    requestFillFrame();
  });

  function initFill(section) {
    if (section.hasAttribute('data-v3-ready')) return;
    section.setAttribute('data-v3-ready', '');

    if (REDUCED_MOTION || !('IntersectionObserver' in window)) {
      section.style.setProperty('--v3-fill', '1');
      return;
    }

    // data-v3-fill="reveal" (system body map): mobile 0 when its top
    // reaches 55% of the screen, 1 when its bottom reaches 50%;
    // desktop 0 when its top reaches 30%, 1 when its bottom reaches 60%.
    // Otherwise (rail lines): the fill line follows mid-screen.
    // Both follow the scroll in either direction.
    var reveal = section.getAttribute('data-v3-fill') === 'reveal';
    var steps = section.hasAttribute('data-v3-steps') ? createSteps(section) : null;

    var item = {
      el: section,
      active: false,
      height: 0,
      last: -1,
      // Layout height (offsetHeight ignores the rail lines' scaleY, which
      // can make their on-screen height 0). Their top edge is unaffected.
      measure: function () { item.height = section.offsetHeight; },
      apply: function (top, view) {
        var h = item.height;
        if (!h) return; // hidden (e.g. desktop-only layout)
        var progress;
        if (!reveal) {
          progress = (view / 2 - top) / h;
        } else if (MOBILE.matches) {
          var mStart = view * 0.55;
          var mEnd = view * 0.5 - h;
          progress = (mStart - top) / Math.max(240, mStart - mEnd);
        } else {
          var start = view * 0.3;
          var end = view * 0.6 - h;
          progress = (start - top) / Math.max(240, start - end);
        }
        progress = Math.round(Math.min(1, Math.max(0, progress)) * 1000) / 1000;
        if (progress === item.last) return; // nothing changed: no style write
        item.last = progress;
        section.style.setProperty('--v3-fill', progress);
        if (steps) steps.update(progress);
      }
    };

    item.measure();
    fills.push(item);
    // Correct start value right away (above, below or on screen)
    item.apply(section.getBoundingClientRect().top, window.innerHeight);

    // Only elements near the screen take part in the frame. A scaled rail
    // line can be 0px tall on screen, so watch its rail instead.
    new IntersectionObserver(function (entries) {
      var wasActive = item.active;
      item.active = entries[0].isIntersecting;
      if (!item.active && wasActive) {
        // leaving: settle it at its end value once
        item.active = true;
        fillFrame();
        item.active = false;
        return;
      }
      if (item.active) {
        item.measure();
        requestFillFrame();
      }
    }, { rootMargin: '100px 0px' }).observe(reveal ? section : section.parentElement || section);
  }

  /* ---------------------------------------------------------------- *
   *  [data-v3-sequence="ms"]: its [data-v3-seq-item] children play one
   *  after another, in page order. An item starts only when the one
   *  before it has finished AND it has scrolled into view (top past 80%
   *  of the viewport), so the draw runs smoothly from first to last
   *  whether the items enter together (desktop row) or one by one
   *  (mobile column). "ms" = how long one item plays.
   *  Items: timeline milestones (.is-armed → .is-in, CSS draws the dot
   *  and line) and donut stats ([data-v3-donut], ring + number count up).
   *  Without JS / reduced motion: everything shows in its final state.
   * ---------------------------------------------------------------- */
  var DONUT_LENGTH = 254.34; // ring length: 2π × 40.48

  function drawDonut(card, value) {
    var ring = card.querySelector('.v3-donut__value');
    var number = card.querySelector('[data-v3-donut-number]');
    if (ring) ring.setAttribute('stroke-dasharray', (DONUT_LENGTH * value / 100).toFixed(2) + ' ' + DONUT_LENGTH);
    if (number) number.textContent = Math.round(value);
  }

  function animateDonut(card, duration) {
    var target = parseFloat(card.getAttribute('data-v3-donut')) || 0;
    var start = null;
    function frame(time) {
      if (start === null) start = time;
      var t = Math.min(1, (time - start) / duration);
      drawDonut(card, target * (1 - Math.pow(1 - t, 3))); // ease-out
      if (t < 1) window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);
  }

  function initSequence(container) {
    if (container.hasAttribute('data-v3-ready')) return;
    container.setAttribute('data-v3-ready', '');

    var items = Array.prototype.slice.call(container.querySelectorAll('[data-v3-seq-item]'));
    var duration = parseInt(container.getAttribute('data-v3-sequence'), 10) || 900;
    if (!items.length) return;

    if (REDUCED_MOTION || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        if (item.hasAttribute('data-v3-donut')) drawDonut(item, parseFloat(item.getAttribute('data-v3-donut')) || 0);
        else item.classList.add('is-in');
      });
      return;
    }

    // Start state
    items.forEach(function (item) {
      if (item.hasAttribute('data-v3-donut')) drawDonut(item, 0);
      else item.classList.add('is-armed');
    });

    var visible = items.map(function () { return false; });
    var next = 0;
    var playing = false;

    function play() {
      if (playing || next >= items.length || !visible[next]) return;
      var item = items[next];
      playing = true;
      if (item.hasAttribute('data-v3-donut')) animateDonut(item, duration);
      else item.classList.add('is-in');
      window.setTimeout(function () {
        playing = false;
        next += 1;
        play();
      }, duration);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        visible[items.indexOf(entry.target)] = true;
        observer.unobserve(entry.target);
      });
      play();
    }, { rootMargin: '0px 0px -20% 0px', threshold: 0 });

    items.forEach(function (item) { observer.observe(item); });
  }

  /* ---------------------------------------------------------------- *
   *  Single-open accordion groups: <details data-v3-accordion="group">.
   * ---------------------------------------------------------------- */
  function initAccordions(root) {
    root.querySelectorAll('details[data-v3-accordion]').forEach(function (item) {
      if (item.hasAttribute('data-v3-ready')) return;
      item.setAttribute('data-v3-ready', '');
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        var group = item.getAttribute('data-v3-accordion');
        document.querySelectorAll('details[data-v3-accordion="' + group + '"][open]').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  /* ---------------------------------------------------------------- *
   *  FrontrowMD "Clinicians' Choice" sticker in the buy box. Their
   *  script shrinks the 78px iframe with transform: scale() on narrow
   *  screens (and shifts it up with its transform-origin), but the
   *  iframe still takes its full 78px in the layout, which leaves an
   *  empty gap under it. Pull the next content up to where the badge
   *  visually ends, every time their script rescales it.
   * ---------------------------------------------------------------- */
  function fitFrontrow(frame) {
    if (frame.hasAttribute('data-v3-ready')) return;
    frame.setAttribute('data-v3-ready', '');
    var lastTransform = null;

    // Untransformed top of an element, in viewport coordinates
    function layoutTop(el) {
      var top = 0;
      for (var node = el; node; node = node.offsetParent) top += node.offsetTop;
      return top - window.pageYOffset;
    }

    function fit(force) {
      // Only react when their script changes the scale (our own margin
      // change also touches the style attribute).
      if (!force && frame.style.transform === lastTransform) return;
      lastTransform = frame.style.transform;

      var visual = frame.getBoundingClientRect(); // includes the scale
      var layoutBottom = layoutTop(frame) + frame.offsetHeight;
      var gap = layoutBottom - visual.bottom;
      frame.style.marginBottom = gap > 1 ? -Math.round(gap) + 'px' : '';
    }

    new MutationObserver(function () { fit(false); })
      .observe(frame, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', function () { fit(true); });
    fit(true);
  }

  function init(root) {
    root.querySelectorAll('[data-v3-router]').forEach(initRouter);
    root.querySelectorAll('[data-v3-reviews]').forEach(initReviews);
    root.querySelectorAll('[data-v3-stories]').forEach(initStories);
    root.querySelectorAll('[data-v3-fill]').forEach(initFill);
    root.querySelectorAll('[data-v3-sequence]').forEach(initSequence);
    root.querySelectorAll('.main_product-container #frontrow-sticker').forEach(fitFrontrow);
    initAccordions(root);
  }

  initScrollLinks();

  function start() {
    relinkGalleries(); // before the ?angle pulse, which targets the slides
    init(document);
    initSelectorSync();
    initGalleryPulse();
    initBottomSelectorView();
    initSticky();
  }

  if (window.jQuery) window.jQuery(start);
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Theme editor re-renders a section after each change.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
